import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import Card from "./card";
// swiper bundle styles
import "swiper/css/bundle";

// swiper core styles
import "swiper/css";

// modules styles
import "swiper/css/navigation";
import "swiper/css/pagination";

const data = [
  {
    fullName: "mostafa mosaddegh",
    job: "Founder of startup 2806",
    avatar:
      "https://cdn.dribbble.com/users/268582/avatars/small/ebbc6b8d7075737a0fbf7f9a30ae6ee8.jpeg?1613939389",
    description:
      "Factory programming is the idea that you can become the owner of a rocket with the help of attractive and practical rocket training.",
    projectLink: "https://2806startup.com",
  },
  {
    fullName: "Nico Nurettin",
    job: "Founder of metayork",
    avatar: "https://i.pravatar.cc/150?img=13",
    description:
      "Factory programming is the idea that you can become the owner of a rocket with the help of attractive and practical rocket training.",
    projectLink: "https://metayork.com",
  },
  {
    fullName: "reza abbaszadeh",
    job: "Founder of BaxBeauty",
    avatar:
      "https://i1.sndcdn.com/avatars-DFFHJXbKK03UYAdG-77bvig-t240x240.jpg",
    description:
      "Factory programming is the idea that you can become the owner of a rocket with the help of attractive and practical rocket training.",
    projectLink: "https://baxbeauty.com",
  },
];

const Index = () => {
  return (
    <>
      <div class="relative grid lg:grid-cols-12 grid-cols-1 lg:container mx-auto px-4 lg:px-24 pb-6 md:pb-44 space-y-4 text-gray-900 dark:text-white  lg:space-x-4">
        <div className="md:col-span-7">
          <p className="text-2xl font-black lg:text-7xl mb-2">
            What do our customers say about us?
          </p>
          <p className="text-base lg:text-2xl text-slate-700 dark:text-slate-400">
            We are proud to work with you. 😍
          </p>
        </div>
        <div className="sm:hidden">
          <svg
            className="absolute right-16 top-12 z-10"
            width="66"
            height="66"
            viewBox="0 0 66 66"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M29.5617 28.0047C29.5017 27.7068 29.4415 27.4085 29.3347 27.1392C30.7603 27.7434 32.0824 28.4909 33.0805 29.2404C41.4596 35.5336 44.5133 49.1795 45.38 59.2993C44.7345 58.6814 44.1396 57.9929 44.0675 57.8799C42.0989 55.9148 40.1896 54.3481 37.2806 54.1701C36.9328 54.1345 36.5984 54.4258 36.5736 54.7946C36.595 55.1339 36.866 55.4571 37.2135 55.4923C39.7783 55.6403 41.3675 57.1127 43.1106 58.8263C43.1403 58.8553 43.213 58.9338 43.3174 59.0463C43.8202 59.5886 45.0577 60.9229 45.7534 61.3384C46.3626 61.6819 46.8375 61.5091 47.0155 61.2785C47.3559 60.8949 47.5641 60.3038 47.7194 59.63C47.765 59.402 47.8079 59.1613 47.8506 58.9217C47.9533 58.3455 48.0547 57.7764 48.188 57.4094C48.2279 57.3105 48.2679 57.2109 48.3081 57.1109C49.4629 54.24 50.7985 50.9197 52.7086 48.5957C52.971 48.2937 52.9071 47.8879 52.6263 47.6515C52.3453 47.4147 51.9183 47.4588 51.7021 47.7313C49.6086 50.2589 48.1472 53.8793 46.9601 56.9106C46.8172 57.2627 46.7262 57.7472 46.6278 58.271C46.6221 58.3015 46.6163 58.3322 46.6105 58.363C45.6181 48.003 42.3084 34.5038 33.8898 28.1651C32.5561 27.1954 30.7536 26.2042 28.8171 25.5125C28.3823 24.3212 27.8936 23.1474 27.3922 21.9537C26.1516 19.0913 24.4574 16.3323 22.6952 13.7734C20.3259 10.3646 17.4522 7.49068 14.0503 5.11296C13.7283 4.91395 13.3177 4.98337 13.1156 5.27806C12.9138 5.57321 12.985 5.99071 13.2607 6.2192C16.5383 8.50393 19.285 11.2807 21.57 14.5574C23.3312 17.013 24.9306 19.7245 26.1705 22.4839C26.5236 23.3431 26.8696 24.1919 27.2111 25.0331C26.2917 24.8147 25.4059 24.6489 24.4837 24.6299C22.0864 24.5408 19.8513 25.2156 18.2804 27.1355C16.8851 28.8212 16.5302 30.5071 16.8436 32.0177C17.282 34.2339 19.149 36.1414 21.3799 37.1928C23.6212 38.2604 26.2494 38.4063 28.0175 37.3052C29.2732 36.5219 30.1618 35.1632 30.3421 32.9997C30.4603 31.4304 30.0107 29.7166 29.6155 28.2099C29.5974 28.141 29.5795 28.0726 29.5617 28.0047ZM28.2675 28.3198C28.14 27.712 27.965 27.1326 27.742 26.5791C26.6706 26.2243 25.5488 25.9945 24.4269 25.9683C22.4822 25.8753 20.6071 26.4004 19.2863 27.9989C18.2259 29.2923 17.9362 30.5712 18.1678 31.7497C18.5011 33.5973 20.117 35.1112 21.967 35.9732C23.7608 36.849 25.8573 37.0786 27.3458 36.1506C28.276 35.5703 28.9008 34.5106 29.0314 32.8807C29.1049 31.6738 28.7794 30.3775 28.4734 29.1588C28.4019 28.8742 28.3315 28.5938 28.2675 28.3198Z"
              className="fill-slate-900 dark:fill-white"
            />
          </svg>
        </div>
        <div className="md:col-span-5">
          <Swiper
            spaceBetween={21}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 21,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 21,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 21,
              },
            }}
          >
            {data.map((item) => (
              <SwiperSlide>
                <Card
                  fullName={item.fullName}
                  job={item.job}
                  avatar={item.avatar}
                  description={item.description}
                  projectLink={item.projectLink}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Index;
